import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import DOMPurify from 'dompurify';
import { Icon, Haldor__Block, addBlockTranslations } from '@haldor/ui';
import './_LinksBlock.scss';
var LinksBlock = /*#__PURE__*/function (_Haldor__Block) {
  function LinksBlock(_props) {
    var _this;
    _classCallCheck(this, LinksBlock);
    _this = _callSuper(this, LinksBlock, [_props]);
    _defineProperty(_this, "addhttp", function (url) {
      if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
        url = "http://" + url;
      }
      return url;
    });
    _defineProperty(_this, "consume", function (props) {
      return /*#__PURE__*/React.createElement("div", {
        className: "block--links consume"
      }, props.resources != null ? /*#__PURE__*/React.createElement("div", {
        className: "link-resource-list"
      }, props.resources.map(function (resource, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: "link-resource-container",
          key: index
        }, /*#__PURE__*/React.createElement("a", {
          className: "link-resource",
          href: _this.addhttp(resource.url),
          target: "_blank"
        }, /*#__PURE__*/React.createElement("div", {
          className: "link-content"
        }, resource.image != '' ? /*#__PURE__*/React.createElement("div", {
          className: "image",
          style: {
            backgroundImage: "url(".concat(resource.image, ")")
          }
        }) : null, /*#__PURE__*/React.createElement("div", {
          className: "content"
        }, /*#__PURE__*/React.createElement("div", {
          className: "title",
          dangerouslySetInnerHTML: {
            __html: DOMPurify.sanitize(resource.title)
          }
        }), /*#__PURE__*/React.createElement("div", {
          className: "description",
          dangerouslySetInnerHTML: {
            __html: DOMPurify.sanitize(resource.description)
          }
        }))), /*#__PURE__*/React.createElement("div", {
          className: "link-footer"
        }, /*#__PURE__*/React.createElement("div", {
          className: "url"
        }, /*#__PURE__*/React.createElement("a", {
          href: _this.addhttp(resource.url),
          target: "_blank"
        }, resource.url, /*#__PURE__*/React.createElement(Icon, {
          name: "External"
        }))))));
      })) : null);
    });
    _defineProperty(_this, "edit", function (props) {
      return null;
    });
    _this.name = 'Haldor.Blocks.Link';
    _this.order = 49;
    _this.svgIcon = function () {
      return /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 50 50",
        dangerouslySetInnerHTML: {
          __html: "\n\t\t\t\t\t<defs><style>.block-icon-link{fill:#c8c9c8;}</style></defs>\n\t\t\t\t\t<path class=\"block-icon-link\" d=\"M27.52,19.64l-7.89,7.9a2,2,0,0,0,0,2.79h0a2,2,0,0,0,2.79,0h0l7.9-7.89a2,2,0,0,0-2.81-2.81Z\"/>\n\t\t\t\t\t<path class=\"block-icon-link\" d=\"M25.53,35.65,23,38.16A8.28,8.28,0,0,1,12,39a7.9,7.9,0,0,1-1.08-11.12c.17-.2.35-.4.54-.59l2.81-2.82a2,2,0,0,0,0-2.79h0a2,2,0,0,0-2.8,0h0L9,24.14A12.15,12.15,0,0,0,7.62,40.08a12,12,0,0,0,17.91,1.18l2.8-2.8a2,2,0,0,0-2.8-2.81Z\"/>\n\t\t\t\t\t<path class=\"block-icon-link\" d=\"M40.1,7.66A12.2,12.2,0,0,0,24.05,9l-2.13,2.17a2.16,2.16,0,0,0-.48,3c0,.06.09.12.14.17a2,2,0,0,0,2.79,0h0L27,11.77A8.22,8.22,0,0,1,38,11a7.9,7.9,0,0,1,1.11,11.11,6.87,6.87,0,0,1-.58.63l-2.8,2.83a2,2,0,0,0,0,2.79h0a2,2,0,0,0,2.79,0h0l2.8-2.8A12,12,0,0,0,41.2,8.63,10.17,10.17,0,0,0,40.1,7.66Z\"/>\n\t\t\t\t\t"
        }
      });
    };
    addBlockTranslations('sv-se', [{
      output: 'Länkar',
      id: 'Haldor.Blocks.Link'
    }]);
    addBlockTranslations('en-us', [{
      output: 'Links',
      id: 'Haldor.Blocks.Link'
    }]);
    addBlockTranslations('nb-no', [{
      output: 'Lenke',
      id: 'Haldor.Blocks.Link'
    }]);
    addBlockTranslations('da-dk', [{
      output: 'Links',
      id: 'Haldor.Blocks.Link'
    }]);
    addBlockTranslations('uk', [{
      output: 'Посилання',
      id: 'Haldor.Blocks.Link'
    }]);
    _this.registerResourceType('haldor.blocks.links.link', {
      title: 'string',
      description: 'string',
      image: 'string',
      url: 'string'
    });
    return _this;
  }
  _inherits(LinksBlock, _Haldor__Block);
  return _createClass(LinksBlock);
}(Haldor__Block);
export default LinksBlock;